import React, {Component} from 'react';

class ExposureTabs extends Component {
    componentDidUpdate() {
        initTabs();
    }

    render() {
        return (
            <ul className="table-tab">
                <li className="active">
                    <a href="#players">Players</a>
                </li>
                <li>
                    <a href="#stack-combinations">Stack Combinations</a>
                </li>
            </ul>
        );
    }
}

export {ExposureTabs};
